<template>
  <div class="admin-table-wrapper">
    <b-row class="top-buttons">
      <b-col>
        <slot name="top-buttons" />
        <b-button v-if="!config.hideActionNewButton &&
          config.useNewModal &&
          config.authFeature &&
          $store.getters['auth/isAuthorized'](config.authFeature + '_new')
          " class="float-right mb-35" variant="outline-primary" size="lg" @click="openFormModal()">
          Nouveau
          <i class="far fa-plus ml-10"></i>
        </b-button>
        <b-button v-else-if="!config.hideActionNewButton &&
          config.authFeature &&
          $store.getters['auth/isAuthorized'](config.authFeature + '_new')
          " class="float-right mb-35" variant="outline-primary" size="lg" :to="{ name: config.newRouteName }">
          Nouveau
          <i class="far fa-plus ml-10"></i>
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div v-if="tab_filter" class="tabs d-flex flex-row" ref="tabs">
          <div :class="{ tab: true, active: !tab_filter_default_value }" @click="setTab($event, null)">
            Tout
          </div>
          <div v-for="option in options[tab_filter.name + '_options']" :key="option.value" :ref="'tab_' + option.value"
            @click="setTab($event, option.value)" :class="{
          tab: true,
          active: option.value == tab_filter_default_value,
        }">
            {{ option.text }}
          </div>
        </div>

        <div class="ibox">
          <div class="ibox-content">
            <div class="filters">
              <div class="d-flex align-items-center">
                <div class="flex-grow-1 search-bar">
                  <b-form-group inline class="mb-0">
                    <b-input-group>
                      <label class="mb-0 align-self-center">
                        <i class="far fa-search fa-lg"></i>
                      </label>
                      <b-form-input v-model="searchInput" placeholder="Rechercher" />
                      <b-input-group-append v-if="searchInput &&
          (!this.config.showExtendedFilters ||
            this.config.showExtendedFilters !== true)
          ">
                        <b-button :disabled="!searchInput" @click="setFilter('')">
                          <i class="far fa-times"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </div>
                <div class="ml-2 filters-toggle" v-if="extended_filters.length &&
          (!this.config.showExtendedFilters || this.config.showExtendedFilters !== true)
          " @click.prevent="toggleExtendedFilters()">
                  <a href v-if="extended_filters_is_open">
                    Moins d'options
                    <i class="fa fa-chevron-up ml-1"></i>
                  </a>
                  <a href v-else>
                    Plus d'options
                    <i class="fa fa-chevron-down ml-1"></i>
                  </a>
                </div>
                <div class="ml-2 filters-toggle" v-else @click.prevent="resetFilters()">
                  <a href>
                    Reset
                    <i class="fa fa-undo ml-1"></i>
                  </a>
                </div>
              </div>
              <b-form v-if="extended_filters.length && extended_filters_is_open" class="extended-filters">
                <b-row>
                  <b-col v-for="extended_filter in extended_filters" :key="extended_filter.name" class="filter-col"
                    :class="extended_filter.filterWidth ? 'filter-col--' + extended_filter.filterWidth : null">
                    <b-form-group :label="extended_filter.label + ' :'" :label-for="'filter-' + extended_filter.name">
                      <b-form-select :id="'filter-' + extended_filter.name" v-if="extended_filter.type == 'select'"
                        v-model="extended_filters_model[extended_filter.name]"
                        :options="options[extended_filter.name + '_options']">
                        <!-- This slot appears above the options from 'options' prop -->
                        <template slot="first">
                          <option :value="null">-- Tout --</option>
                        </template>
                      </b-form-select>
                      <Chosen :id="'filter-' + extended_filter.name" v-if="extended_filter.type == 'chosen'"
                        v-model="extended_filters_model[extended_filter.name]"
                        :options="options[extended_filter.name + '_options']" allowAll="true" label="text"
                        trackBy="value" searchContains="true"></Chosen>
                      <div v-if="extended_filter.type == 'date'" class="d-flex">
                        <datepicker :id="'filter-' + extended_filter.name" input-class="form-control"
                          v-model="extended_filters_model[extended_filter.name]['start']" :format="'dd/MM/yyyy'"
                          :monday-first="true" :language="fr" :clear-button="true"
                          clear-button-icon="fa fa-times fa-lg">
                        </datepicker>
                        <div class="align-self-center ml-1 mr-1">Au</div>
                        <datepicker :id="'filter-' + extended_filter.name + '-2'" input-class="form-control"
                          v-model="extended_filters_model[extended_filter.name]['end']" :format="'dd/MM/yyyy'"
                          :monday-first="true" :language="fr" :clear-button="true"
                          clear-button-icon="fa fa-times fa-lg">
                        </datepicker>
                      </div>
                      <b-form-input v-if="extended_filter.type == 'text'" class="flex-fill"
                        :id="'filter-' + extended_filter.name" type="text"
                        v-model="extended_filters_model[extended_filter.name]" />
                      <!-- Filtre autocomplete : le composant est nommé par la config
                           (filterComponent) et doit être enregistré globalement. Sert aux
                           référentiels trop volumineux pour un <select> (ex. employés). -->
                      <!-- Options passées seulement si la vue en fournit (OptionsAutocomplete) :
                           les autocompletes qui chargent leur référentiel n'en attendent pas. -->
                      <component v-if="extended_filter.type == 'autocomplete'"
                        :is="extended_filter.filterComponent" :id="'filter-' + extended_filter.name"
                        :placeholder="extended_filter.filterPlaceholder"
                        v-bind="options[extended_filter.name + '_options'] ? { options: options[extended_filter.name + '_options'] } : {}"
                        v-model="extended_filters_model[extended_filter.name]" />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-form>
            </div>

            <b-row class="mt-4">
              <b-col>
                <div class="d-flex align-items-center">
                  <b-form-checkbox v-if="!config.hideActionCsvButton && totalRows" class="select-all"
                    v-model="allSelected" :value="true" :unchecked-value="false" @change="toggleSelectAll">
                    Tout sélectionner
                    <span v-if="selectedRowsCount" class="text-lowercase">({{ selectedRowsCount | thousands }} lignes
                      sélectionnées)</span>
                  </b-form-checkbox>
                  <b-form inline class="ml-auto">
                    <!-- QR-005 : point d'extension pour les actions groupées propres à une
                         liste (ex. impression d'étiquettes). Purement additif : les listes
                         qui ne fournissent pas ce slot sont inchangées. -->
                    <slot name="bulk-actions" :selected-rows="selectedRows"></slot>
                    <download-csv v-if="!config.hideActionCsvButton && selectedRowsCount"
                      class="btn btn-outline-primary" :data="exportCsvRows" :fields="exportCsvFields"
                      :labels="exportCsvLabels" :name="exportCsvFilename" delimiter=";">Exporter en CSV</download-csv>
                    <b-form-group class="mb-0 ml-10">
                      <b-input-group>
                        <b-form-select v-model="perPage" :options="perPageOptions" />
                      </b-input-group>
                    </b-form-group>
                  </b-form>
                </div>
              </b-col>
            </b-row>

            <div class="table-wrapper mt-2">
              <b-table ref="table" id="admin-table-sync" hover show-empty :fields="fields" :items="itemsProvider"
                :sort-by="config.sortBy || null" :sort-desc="config.sortDesc || false" :filter="filter"
                :current-page="currentPage" :per-page="parseInt(perPage)" :selectable="!config.hideActionCsvButton"
                :select-mode="'multi'" selectedVariant="info" @row-selected="rowSelected" :busy="isBusy"
                :tbody-tr-class="config.rowClass || null">
                <div slot="table-busy" class="text-center my-2">
                  <div v-if="isBusy" class="loader"></div>
                  Les données sont en cours de chargement...
                </div>
                <template slot="empty" slot-scope="scope">
                  <div v-if="config.newRouteName" class="text-center mt-2">
                    Cette liste est vide pour le moment, soyez le premier à créer un enregistrement
                    <!-- <br>
                    <b-button
                      v-if="config.useNewModal && config.authFeature && $store.getters['auth/isAuthorized'](config.authFeature+'_new')"
                      class="mt-2 mb-2"
                      variant="outline-primary"
                      size="lg"
                      @click="openFormModal()"
                    >
                      Nouveau
                      <i class="far fa-plus ml-10"></i>
                    </b-button>
                    <b-button
                      v-else-if="config.authFeature && $store.getters['auth/isAuthorized'](config.authFeature+'_new')"
                      class="mt-2 mb-2"
                      variant="outline-primary"
                      size="lg"
                      :to="{name:config.newRouteName}"
                    >Nouveau</b-button>-->
                  </div>
                  <div v-else class="text-center mt-2">Cette liste est vide pour le moment</div>
                </template>
                <template slot="emptyfiltered" slot-scope="scope">
                  <div class="text-center mt-2">Aucun résultat ne correspond à la recherche</div>
                </template>

                <template slot="select" slot-scope="data">
                  <b-form-checkbox :name="'select-' + data.item.id" :checked="data.rowSelected"
                    @change="toggleSelectRow(data.index + 1)"></b-form-checkbox>
                </template>
                <template v-for="field in config.fields.filter((field) => field.inList == true)" :slot="field.name"
                  slot-scope="data">
                  <b-badge v-if="field.type == 'yesno' && data.value == true" :key="field.name" variant="success"
                    class="circle float-left">
                    <i class="fa fa-check"></i>
                  </b-badge>
                  <b-badge v-else-if="field.type == 'yesno' && data.value == false" :key="field.name" variant="danger"
                    class="circle float-left">
                    <i class="fa fa-times"></i>
                  </b-badge>
                  <template v-else-if="field.type == 'date' && data.value">{{
          data.value | moment("DD-MM-YYYY")
        }}</template>
                  <slot v-else :name="field.name" :data="data">{{ data.value }}</slot>
                </template>

                <template :slot="config.titleField" slot-scope="data">
                  <router-link v-if="config.detailRouteName &&
          config.authFeature &&
          $store.getters['auth/isAuthorized'](config.authFeature + '_show')
          " :to="{
          name: config.detailRouteName,
          params: { id: data.item.id },
        }">
                    <template v-if="config.fields.find((field) => field.name == config.titleField).type ==
          'date'
          ">{{ data.value | moment("DD-MM-YYYY") }}</template>
                    <template v-else>{{ data.value }}</template>
                  </router-link>
                  <template v-else>{{ data.value }}</template>
                </template>
                <template slot="actions" slot-scope="data">
                  <b-button-group size="sm" class="actions">
                    <slot name="actions" :data="data"></slot>
                    <b-button v-b-tooltip.hover title="Editer" variant="outline-secondary" v-if="config.useEditModal &&
          !config.hideActionEditButton &&
          data.item.id &&
          ((config.editCondition && config.editCondition(data.item)) ||
            !config.editCondition) &&
          config.authFeature &&
          $store.getters['auth/isAuthorized'](config.authFeature + '_edit')
          " @click="openFormModal(data.item.id)">
                      <i class="far fa-pencil"></i>
                    </b-button>
                    <b-button v-b-tooltip.hover title="Editer" variant="outline-secondary" v-if="!config.useEditModal &&
          !config.hideActionEditButton &&
          data.item.id &&
          ((config.editCondition && config.editCondition(data.item)) ||
            !config.editCondition) &&
          config.authFeature &&
          $store.getters['auth/isAuthorized'](config.authFeature + '_edit')
          " :to="{
          name: config.editRouteName,
          params: { id: data.item.id },
        }">
                      <i class="far fa-pencil"></i>
                    </b-button>
                    <b-button v-b-tooltip.hover title="Exporter en PDF" variant="outline-secondary"
                      v-if="!config.hideActionPdfButton && data.item.id" @click.prevent="exportPdfSingle(data.item)">
                      <i class="far fa-file-alt"></i>
                    </b-button>
                    <b-button v-b-tooltip.hover title="Supprimer" variant="outline-secondary" v-if="!config.hideActionDeleteButton &&
          data.item.id &&
          ((config.deleteCondition && config.deleteCondition(data.item)) ||
            !config.deleteCondition) &&
          config.authFeature &&
          $store.getters['auth/isAuthorized'](config.authFeature + '_delete')
          " @click.prevent="deleteItem(data.item.id)">
                      <i class="far fa-trash-alt"></i>
                    </b-button>
                  </b-button-group>
                </template>
              </b-table>
            </div>

            <div class="total float-right">
              {{ resultsCount | thousands }} / <strong>{{ totalRows | thousands }}</strong> résultats
            </div>

            <!-- Recréée quand le total arrive : rendue avec un total nul, elle ramène sa page
                 interne à 1 et ne la recale plus — une page restaurée depuis l'URL s'affichait
                 « 1 » alors que la liste montrait la bonne. -->
            <b-pagination :key="totalRows > 0" class="mb-0" align="center" size="sm" :total-rows="totalRows"
              :per-page="parseInt(perPage)" v-model="currentPage" />
          </div>
        </div>
      </b-col>
    </b-row>

    <AdminModalForm v-if="config.useNewModal || config.useEditModal" :config="config" :id_to_edit="id_to_edit"
      @submit:create:success="submitCreateSuccess" @submit:update:success="submitUpdateSuccess"
      @submit:create:error="submitCreateError" @submit:update:error="submitUpdateError" />
  </div>
</template>

<script>
import AdminModalForm from "@/components/Global/AdminModalForm";
import Datepicker from "vuejs-datepicker";
import { en, fr } from "vuejs-datepicker/dist/locale";
import Chosen from "@/components/Global/Chosen";

// Délai sans frappe avant de lancer la recherche
const SEARCH_DEBOUNCE_MS = 400;

export default {
  name: "AdminTable",
  components: {
    AdminModalForm,
    Datepicker,
    Chosen,
  },
  props: ["config", "options", "items_provider"],
  data() {
    return {
      totalRows: 0,
      resultsCount: 0,
      fields: [],
      currentPage: 1,
      perPage: 20,
      perPageOptions: {
        10: "10 par page",
        20: "20 par page",
        50: "50 par page",
        100: "100 par page",
        999999999: "Tout afficher", // On ne met pas une valeur vide car cela aurait pour conséquence de ne pas appliquer d'attribut aria-rowindex sur les lignes. Et on en a besoin pour l'usage des checkbox
      },
      allSelected: false,
      selectedRowsCount: 0,
      // QR-005 : lignes sélectionnées, exposées au slot bulk-actions.
      selectedRows: [],
      exportCsvFields: [],
      exportCsvLabels: {},
      exportCsvRows: [],
      exportCsvFilename:
        this.config.csvExportFilenamePrefix + "-" + this.$moment().format("YYYY-MM-DD") + ".csv",
      isBusy: false,
      filter: null,
      // Saisie brute du champ de recherche : `filter` (surveillé par b-table, qui
      // rappelle le provider à chaque changement) n'en reprend la valeur qu'après
      // SEARCH_DEBOUNCE_MS sans frappe, pour ne pas lancer une requête par caractère.
      searchInput: null,
      searchDebounceTimer: null,
      // Devient true une fois le composant monté : empêche d'écrire dans l'URL
      // pendant l'initialisation (valeurs par défaut, restauration depuis l'URL)
      urlSyncReady: false,
      // Même bascule pour les filtres : tant qu'elle est fausse, leurs valeurs sont
      // posées par le composant (défauts, restauration depuis l'URL) et non par
      // l'utilisateur — ni retour à la page 1, ni rechargement de la liste.
      filtersReady: false,
      extended_filters: [],
      extended_filters_model: {},
      // Choix "Plus d'options" mémorisé par liste (store table_pref + localStorage) ;
      // à défaut, valeur par défaut de la config.
      extended_filters_is_open: (() => {
        const key = this.config && this.config.storeNamespace;
        const saved = key ? this.$store.getters["table_pref/extendedFiltersOpen"](key) : undefined;
        return saved === true || saved === false ? saved : (this.config.showExtendedFilters || false);
      })(),
      tab_filter: null,
      tab_filter_default_value: null,
      id_to_edit: null,
      // Id de la fiche en cours d'édition dans la modale (reporté dans l'URL
      // pour rouvrir la modale au rafraîchissement)
      editId: null,
      en: en,
      fr: fr,
    };
  },
  watch: {
    // Saisie dans le champ de recherche : appliquée au filtre une fois la frappe terminée
    searchInput: function (value) {
      clearTimeout(this.searchDebounceTimer);
      if (value === this.filter) {
        return;
      }
      this.searchDebounceTimer = setTimeout(() => {
        this.filter = value;
      }, SEARCH_DEBOUNCE_MS);
    },
    // Quand le champ de recherche change
    filter: {
      handler: function (newFiltersValues) {
        if (this.filtersReady) {
          this.currentPage = 1;
        }
        this.syncFiltersToUrl();
      },
    },
    // Quand les filtres étendus changent
    extended_filters_model: {
      handler: function (newFiltersValues) {
        // Les colonnes peuvent dépendre des filtres (cf. buildListFields).
        this.buildListFields();
        // Au montage, `mounted()` remplit ce modèle (valeurs par défaut, filtre
        // d'onglet, restauration depuis l'URL) : rafraîchir ici doublait le premier
        // chargement, b-table appelant déjà le provider depuis son propre `mounted`,
        // et après celui du parent — donc avec ces filtres-là. Le retour à la page 1
        // écrasait au passage la page restaurée depuis l'URL.
        if (this.filtersReady) {
          this.currentPage = 1;
          this.extentedFiltersFunction();
        }
        this.syncFiltersToUrl();
      },
      deep: true,
    },
    currentPage: function () {
      this.syncFiltersToUrl();
      this.scrollToTop();
    },
    perPage: function () {
      this.syncFiltersToUrl();
    },
  },
  created() {
    // Recherche et pagination sont restaurées avant le premier rendu : b-table les
    // reçoit en props (`:filter`, `:current-page`, `:per-page`) et rappelle son
    // provider dès qu'une d'elles change ensuite. Restaurées depuis `mounted()`,
    // elles arrivaient après le premier rendu : la page 1 partait au serveur pour
    // rien, aussitôt suivie de la page réellement demandée.
    this.applyPaginationFromQuery();
  },
  mounted() {
    // On récupère la liste des filtres étendus (en plus du champ de recherche).
    // `filterOrder` permet de composer la grille de filtres sans toucher à l'ordre des
    // champs, qui pilote aussi les colonnes de la liste et du formulaire. Le tri étant
    // stable, les configs qui ne le renseignent pas gardent l'ordre de `fields`.
    this.extended_filters = this.config.fields
      .filter((field) => field.extendedFilter == true)
      .sort((a, b) => (a.filterOrder || 0) - (b.filterOrder || 0));
    const extended_filters_model = {};
    this.extended_filters.forEach((filter) => {
      if (filter.type == "date") {
        extended_filters_model[filter.name] = {
          start: null,
          end: null,
        };
      } else {
        extended_filters_model[filter.name] = null;
      }
    });
    this.extended_filters_model = extended_filters_model;

    // On récupère le filtre par onglet, et on l'ajoute au model des filtres etendus
    this.tab_filter = this.config.fields.find((field) => field.tabFilter == true) || null;
    if (this.tab_filter && this.tab_filter) {
      extended_filters_model[this.tab_filter.name] = null;
      this.extended_filters_model = extended_filters_model;
    }

    // Valeur par défaut du filtre par onglet (si défini)
    if (this.tab_filter) {
      this.tab_filter_default_value = this.tab_filter.tabFilterDefaultValue || null;
      this.extended_filters_model[this.tab_filter.name] = this.tab_filter_default_value;
    }

    // Filtrage par url
    if (this.$route.params.hasOwnProperty('defaultFilterField') && this.$route.params.hasOwnProperty('defaultFilterValue')) {

      let fields = this.$route.params.defaultFilterField.split(',')
      let values = this.$route.params.defaultFilterValue.split(',')

      for (let i = 0; i < fields.length; i++) {
        if (this.extended_filters_model.hasOwnProperty(fields[i])) {
          if (fields[i] == 'status') {
            this.tab_filter_default_value = values[i] == 'null' ? null : values[i]
          }
          this.extended_filters_model[fields[i]] = values[i] == 'null' ? null : values[i];
        }
      }
      }

    // Restauration des filtres depuis la query string de l'URL (prioritaire sur les
    // valeurs par défaut), afin de conserver la vue courante au rafraîchissement
    this.applyFiltersFromQuery();

    // Chargement des champs à afficher dans la liste depuis la config pour les passer au composant AdminTable
    this.buildListFields();

    // Chargement des champs à exporter en CSV depuis la config pour les passer au composant AdminTable
    this.exportCsvFields = this.config.fields
      .filter((field) => field.inCsvExport == true)
      .map((field) => field.name);
    this.config.fields
      .filter((field) => field.inCsvExport == true)
      .forEach((field) => {
        this.exportCsvLabels[field.name] = field.label;
      });

    this.$root.$on("refresh", this.extentedFiltersFunction);

    // Quand la modale d'édition / création se ferme, on retire le paramètre de l'URL
    this.$root.$on("bv::modal::hidden", this.onModalHidden);

    // À partir d'ici, les changements de filtres proviennent de l'utilisateur :
    // on autorise la synchronisation vers l'URL
    this.$nextTick(() => {
      this.urlSyncReady = true;
      this.filtersReady = true;

      // Réouverture de la modale d'édition si un id est présent dans l'URL
      const editId = this.$route.query.edit;
      if (editId && (this.config.useEditModal || this.config.useNewModal)) {
        this.openFormModal(parseInt(editId));
      }
    });
  },
  beforeDestroy() {
    clearTimeout(this.searchDebounceTimer);
    this.$root.$off("bv::modal::hidden", this.onModalHidden);
  },
  methods: {
    /**
     * Applique immédiatement une recherche (restauration depuis l'URL, bouton
     * d'effacement, remise à zéro), sans attendre le debounce de la saisie.
     */
    setFilter(value) {
      clearTimeout(this.searchDebounceTimer);
      this.filter = value;
      this.searchInput = value;
    },
    /**
     * Compose les colonnes de la liste à partir de la config.
     *
     * Un champ peut porter un `inListCondition(filtres)` : la colonne n'apparaît alors
     * que si le prédicat accepte l'état courant des filtres étendus. C'est le pendant,
     * pour la liste, du `inFormCondition` déjà utilisé par les formulaires — même
     * grammaire de config, même intention : ne montrer que ce qui a du sens dans le
     * contexte. Une liste qui mélange plusieurs natures d'objets (« Produits spéciaux »
     * et sa nature « Location pour compte », sans stock ni prix de vente) aligne ainsi
     * ses colonnes sur ce que l'utilisateur a filtré, au lieu d'afficher des colonnes
     * qu'elle sait vides.
     *
     * Recomposée à chaque changement de filtre (cf. watch `extended_filters_model`).
     */
    buildListFields() {
      const fields = this.config.fields
        .filter(
          (field) =>
            field.inList == true &&
            (!field.inListCondition || field.inListCondition(this.extended_filters_model))
        )
        .map((field) => ({
          key: field.name,
          label: field.label,
          sortable: field.sortable || false,
        }));

      // Si l'export CSV est activé, on ajoute une colonne avec checkbox pour la sélection des lignes
      if (!this.config.hideActionCsvButton) {
        fields.unshift({ key: "select", label: "" });
      }
      if (
        (!this.config.hideActionEditButton &&
          this.config.authFeature &&
          this.$store.getters["auth/isAuthorized"](this.config.authFeature + "_edit")) ||
        !this.config.hideActionPdfButton ||
        (!this.config.hideActionDeleteButton &&
          this.config.authFeature &&
          this.$store.getters["auth/isAuthorized"](this.config.authFeature + "_delete")) ||
        this.$scopedSlots.actions
      ) {
        fields.push({ key: "actions", label: "Actions" });
      }

      this.fields = fields;
    },
    /**
     * Restaure la recherche et la pagination depuis la query string de l'URL.
     *
     * Appelée depuis `created()`, donc avant que b-table ne soit rendue : ces trois
     * valeurs sont des props de la table, qu'elle surveille pour redemander ses
     * données. Les poser plus tard coûtait un aller-retour serveur inutile.
     */
    applyPaginationFromQuery() {
      const query = this.$route.query || {};

      if (query.hasOwnProperty("search")) {
        this.setFilter(query.search || "");
      }
      if (query.hasOwnProperty("perPage")) {
        this.perPage = parseInt(query.perPage) || this.perPage;
      }
      if (query.hasOwnProperty("page")) {
        // Le retour à la page 1 des watchers de filtres est neutralisé pendant
        // l'initialisation (cf. `filtersReady`), la page restaurée tient donc.
        this.currentPage = parseInt(query.page) || 1;
      }
    },
    /**
     * Restaure l'état des filtres étendus et de l'onglet depuis la query string de
     * l'URL. Permet de retrouver la même vue après un rafraîchissement de la page.
     */
    applyFiltersFromQuery() {
      const query = this.$route.query || {};
      const new_model = { ...this.extended_filters_model };
      Object.keys(new_model).forEach((name) => {
        // On ne gère que les filtres scalaires (select / chosen / texte),
        // pas les filtres date qui sont des objets { start, end }
        if (typeof new_model[name] === "object" && new_model[name] !== null) return;
        if (query.hasOwnProperty(name)) {
          new_model[name] = query[name] === "null" ? null : query[name];
        }
      });

      // Onglet (tab filter) : on aligne l'onglet actif sur la valeur de l'URL
      if (this.tab_filter) {
        if (query.hasOwnProperty(this.tab_filter.name)) {
          const tabValue = query[this.tab_filter.name];
          this.tab_filter_default_value = tabValue === "null" ? null : tabValue;
        } else {
          // Si l'URL porte un autre filtre mais pas l'onglet, c'est que
          // l'utilisateur avait sélectionné « Tout » (on n'applique pas l'onglet
          // par défaut). On ignore les clés non filtrantes (edit, page, etc.).
          const hasOtherFilter = Object.keys(new_model).some(
            (key) => key !== this.tab_filter.name && query.hasOwnProperty(key)
          );
          if (hasOtherFilter) {
            this.tab_filter_default_value = null;
            new_model[this.tab_filter.name] = null;
          }
        }
      }

      this.extended_filters_model = new_model;
    },
    /**
     * Reporte l'état courant des filtres dans la query string de l'URL.
     */
    syncFiltersToUrl() {
      if (!this.urlSyncReady) return;

      const query = {};

      if (this.filter) query.search = this.filter;
      if (this.currentPage && this.currentPage > 1) query.page = String(this.currentPage);
      if (this.perPage && parseInt(this.perPage) !== 20) query.perPage = String(this.perPage);
      if (this.editId) query.edit = String(this.editId);
      // Paramètres propres à la page (ex. modale ouverte), conservés tels quels
      (this.config.urlKeepParams || []).forEach((name) => {
        if (this.$route.query.hasOwnProperty(name)) query[name] = this.$route.query[name];
      });

      Object.keys(this.extended_filters_model).forEach((name) => {
        const value = this.extended_filters_model[name];
        // Onglet « Tout » d'une liste qui s'ouvre sur un autre onglet : il doit figurer dans
        // l'URL, sinon un lien vers `?page=400` rouvrait l'onglet par défaut — souvent bien
        // plus court — sur une page vide. `null` est relu par applyFiltersFromQuery().
        if (
          this.tab_filter &&
          name === this.tab_filter.name &&
          value === null &&
          this.tab_filter.tabFilterDefaultValue
        ) {
          query[name] = "null";
          return;
        }
        if (value === null || value === undefined || value === "") return;
        // Filtres date (objets) non gérés dans l'URL
        if (typeof value === "object") return;
        query[name] = String(value);
      });

      // Évite l'erreur vue-router "NavigationDuplicated" si rien n'a changé
      const normalize = (obj) =>
        Object.keys(obj)
          .sort()
          .map((key) => key + "=" + obj[key])
          .join("&");
      if (normalize(query) === normalize(this.$route.query || {})) return;

      this.$router.replace({ query }).catch(() => {});
    },
    /**
     * Gère l'apparition ou le masquage des filtres étendus
     */
    toggleExtendedFilters() {
      this.extended_filters_is_open = !this.extended_filters_is_open;

      // Mémorise le choix "Plus / Moins d'options" pour cette liste (persisté).
      if (this.config && this.config.storeNamespace) {
        this.$store.dispatch("table_pref/setExtendedFiltersOpen", {
          key: this.config.storeNamespace,
          open: this.extended_filters_is_open,
        });
      }

      // Si on ferme les filtres, on reset ceux-ci
      if (!this.extended_filters_is_open) {
        this.resetFilters();
      }
    },
    /**
     * Remise à zéro de tous les filtres
     */
    resetFilters() {
      this.setFilter("");

      this.extended_filters.forEach((filter) => {
        if (filter.type == "date") {
          this.extended_filters_model[filter.name] = {
            start: null,
            end: null,
          };
        } else {
          this.extended_filters_model[filter.name] = null;
        }
      });
    },
    /**
     * Remonte en haut de page au changement de page : la pagination est sous le tableau,
     * si bien qu'on y arrive en bas et qu'on y restait — la nouvelle page s'ouvrait sur
     * ses dernières lignes, l'en-tête et les filtres hors écran.
     *
     * Le changement de route est traité ailleurs (`router.js`, scrollBehavior) : la
     * pagination ne change que la query, elle n'y passe donc pas.
     */
    scrollToTop() {
      window.scrollTo({ top: 0, left: 0 });
    },
    /**
     * Méthode appelée par b-table pour la récupération des données
     * https://bootstrap-vue.js.org/docs/components/table/#using-items-provider-functions
     * @param   {object}  ctx   Objet context envoyé par b-table
     * @returns {array}         Items à afficher
     */
    itemsProvider(ctx) {
      ctx = {
        ...ctx,
        extended_filters_model: this.extended_filters_model,
      };
      return this.items_provider(ctx)
        .then((payload) => {
          this.totalRows = payload.total;
          this.resultsCount = payload.items.length;
          return this.$root.formatDatas(
            payload.items,
            this.config.fields.filter((field) => field.inList == true),
            true
          );
        })
        .catch();
    },
    /**
     * Toggle la sélection de tous les items
     */
    toggleSelectAll() {
      if (!this.allSelected) {
        this.selectAll();
      } else {
        this.unselectAll();
      }
    },
    /**
     * Sélection de toutes les lignes
     */
    selectAll() {
      var self = this;

      $(self.$refs.table.$el).find("tbody tr:not(.b-row-selected)").trigger("click");
    },
    /**
     * Désélection de toutes les lignes
     */
    unselectAll() {
      $(this.$refs.table.$el).find("tbody tr.b-row-selected").trigger("click");
    },
    /**
     * Toggle la sélection d'une ligne lorsque la checkbox est cochée ou décochée
     * @param {integer} index index de la ligne (commence à 1 pour la première ligne)
     */
    toggleSelectRow(index) {
      $(this.$refs.table.$el)
        .find("tbody tr[aria-rowindex='" + index + "']")
        .trigger("click");
    },
    /**
     * Supprime un item (via le store)
     * @param {integer} id  Id de l'item à supprimer
     */
    deleteItem(id) {
      if (confirm("Êtes-vous sur de vouloir supprimer cet élément ?")) {
        this.$store
          .dispatch(this.config.storeNamespace + "/deleteItem", id)
          .then((response) => {
            this.$emit("delete:success", response);
          })
          .catch((error) => {
            this.$emit("delete:error", error);
          });
      }
    },
    /**
     * Fonction de filtrage via les filtres étendus (inclus les onglets)
     */
    extentedFiltersFunction() {
      this.$refs.table.refresh();
    },
    /**
     * Callback appelé lorsqu'une ou des lignes sont sélectionnées
     * Prépare les données pour les exports CSV et PDF selon les lignes sélectionnées
     * @param   {array} rows  Tableau des lignes sélectionnées
     */
    rowSelected(rows) {
      // Dans le cas ou on sélectionne toutes les lignes on coche la checkbox "Sélectionner tout"
      // inversement, si on déselectionne une ligne, on décoche la checkbox "Sélectionner tout"
      this.allSelected =
        this.totalRows < this.perPage ? rows.length == this.totalRows : rows.length == this.perPage;

      this.selectedRowsCount = rows.length;

      // QR-005 : expose la sélection aux actions groupées (slot bulk-actions).
      this.selectedRows = rows;

      this.exportCsvRows = this.buildExportRows(rows);
    },
    /**
     * Met en forme des lignes pour l'export CSV (colonnes `inCsvExport` de la config).
     * @param   {array} rows  lignes à exporter
     * @returns {array}       lignes prêtes pour download-csv
     */
    buildExportRows(rows) {
      var formattedRows = [];
      rows.forEach((row) => {
        formattedRows.push({
          ...row,
          ...this.$root.formatData(
            row,
            this.config.fields.filter(
              (field) => field.inCsvExport == true && (field.inList != true || field.type == "date")
            )
          ),
        });
      });

      return formattedRows.map((row) => {
        let output = {};
        this.config.fields
          .filter((field) => field.inCsvExport == true)
          .forEach((field) => {
            // csvFormatter : mise en forme propre à l'export, pour les colonnes dont la
            // valeur n'est pas une chaîne (objet, collection) et que le rendu de la liste
            // affiche via un slot.
            if (field.csvFormatter) {
              output[field.name] = field.csvFormatter(row[field.name], row, this);
              return;
            }
            output[field.name] =
              field.type = "number" ? (row[field.name] ? row[field.name].toString().replaceDotByComma() : '' ) : (
              field.type == "yesno"
                ? row[field.name] == true
                  ? "Oui"
                  : "Non"
                : row[field.name] || null);
          });
        return output;
      });
    },
    /**
     * Sélectionne un filtre par onglet
     * La valeur de l'onget est ajoutée au filtres étendus afin de filtrer la liste courante
     * @param {string}  value valeur de l'onglet
     */
    setTab(e, value) {
      this.$refs.tabs.querySelector(".tab.active").classList.remove("active");
      e.target.classList.add("active");
      let new_extended_filters_model = { ...this.extended_filters_model };
      new_extended_filters_model[this.tab_filter.name] = value;
      this.extended_filters_model = new_extended_filters_model;
      this.$emit("setTab", value);
    },
    /**
     * Exporte en PDF une seule ligne (bouton sur la ligne)
     * Prépare les données pour les envoyer à la fonction globale exportPdf()
     * @param {integer} item  Item à exporter
     */
    exportPdfSingle(item) {
      this.$store
        .dispatch(this.config.storeNamespace + "/getItem", {
          id: item.id,
          wait: true,
        })
        .then(() => {
          item = this.$store.getters[this.config.storeNamespace + "/getItem"](item.id);

          let formattedItem = this.$root.formatData(
            item,
            this.config.fields.filter((field) => field.inPdfExport == true)
          );

          let exportPdfData = {
            title: this.config.pdf_export_title
              ? this.config.pdf_export_title(item, formattedItem, this)
              : item[this.config.titleField],
            link: this.config.pdf_export_link
              ? this.config.pdf_export_link(item, formattedItem, this)
              : null,
            infos: [],
          };

          if (this.config.pdf_export_logo) {
            exportPdfData.logo = this.config.pdf_export_logo;
          }

          if (this.config.pdf_export_extra_content_before) {
            exportPdfData.extra_content_before = this.config.pdf_export_extra_content_before(
              item,
              formattedItem,
              this
            );
          }

          if (this.config.pdf_export_custom_main_content) {
            exportPdfData.custom_main_content = this.config.pdf_export_custom_main_content(
              item,
              formattedItem,
              this
            );
          } else {
            this.config.fields
              .filter((field) => field.inPdfExport == true)
              .forEach((field) => {
                exportPdfData.infos.push([
                  field.label + " :",
                  field.type == "yesno"
                    ? formattedItem[field.name] == true
                      ? "Oui"
                      : "Non"
                    : formattedItem[field.name] || null,
                ]);
              });
          }

          let lists = this.config.fields.filter((field) => field.type == "list");
          exportPdfData.lists = [];
          if (lists && lists.length) {
            lists.forEach((list) => {
              let currentList = {
                label: list.label,
                infos: [
                  list.fields.map((field) => list.config.fields.find((f) => f.name == field).label),
                ],
              };

              if (item[list.name]) {
                this.$root
                  .formatDatas(
                    item[list.name],
                    list.config.fields.filter((field) => field.inPdfExport == true)
                  )
                  .forEach((item) => {
                    let infosItem = [];
                    list.fields.forEach((field) => {
                      infosItem.push(item[field] || null);
                    });
                    currentList.infos.push(infosItem);
                  });
              }

              exportPdfData.lists.push(currentList);
            });
          }

          if (this.config.pdf_export_extra_lists) {
            exportPdfData.lists.push(
              ...this.config.pdf_export_extra_lists(item, formattedItem, this)
            );
          }

          if (this.config.pdf_export_extra_content_after) {
            exportPdfData.extra_content_after = this.config.pdf_export_extra_content_after(
              item,
              formattedItem,
              this
            );
          }

          this.$root.exportPdf(exportPdfData);
        });
    },
    openFormModal(id) {
      this.id_to_edit = id;
      // On ne reporte dans l'URL que l'édition (avec un id), pas la création
      this.editId = id || null;
      this.syncFiltersToUrl();
      this.$root.$emit("bv::show::modal", "admin_modal_form");
    },
    /**
     * Retire le paramètre d'édition de l'URL à la fermeture de la modale
     */
    onModalHidden(bvEvent, modalId) {
      if (modalId === "admin_modal_form") {
        this.editId = null;
        this.syncFiltersToUrl();
      }
    },
    submitCreateSuccess(response) {
      // Les lignes sont chargées côté serveur (items_provider) : contrairement à
      // AdminTable qui lit le store, rien ne les met à jour toute seule après un
      // enregistrement dans la modale. On relance donc la requête.
      this.$refs.table.refresh();
      this.$emit("submit:create:success", response);
    },
    submitUpdateSuccess(response) {
      this.$refs.table.refresh();
      this.$emit("submit:update:success", response);
    },
    submitCreateError(error) {
      this.$emit("submit:create:error", error);
    },
    submitUpdateError(error) {
      this.$emit("submit:update:error", error);
    },
    refresh() {
      this.$root.$emit('bv::refresh::table', 'admin-table-sync');
    },
  },
};

function resolve(obj, path) {
  path = path.split(".");
  var current = obj;
  while (path.length) {
    if (typeof current !== "object") return undefined;
    current = current[path.shift()];
  }
  return current;
}
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/_variables.scss";

.top-buttons {
  margin-top: -85px;
  min-height: 85px;
}

.tabs {
  background-color: $bg-1;
  width: 100%;
  border-radius: 0;
  overflow: hidden;

  .tab {
    padding: 15px 20px;
    text-align: center;
    text-transform: uppercase;
    @extend .clanprobold;
    color: $primary-darker;
    font-size: 13px;
    opacity: 0.5;
    cursor: pointer;

    &.active {
      color: $primary;
      opacity: 1;
      background-color: #fff;
      border-radius: 0;
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    }
  }
}

.filters {
  border: solid 1px $border-10p;
  padding: 6px 20px;
  border-radius: 0;

  .search-bar {
    color: $text-50p;

    input {
      border: none;
      @extend .clanprobook;
    }

    button.btn {
      color: inherit;
      background: none;
      border: none;
    }
  }

  .filters-toggle a {
    @extend .clanprobold;
    color: $text-50p;
    text-transform: uppercase;
  }

  // Filtres étendus : séparés de la barre de recherche par un filet, à fond perdu
  // (marges négatives compensant le padding de .filters).
  .extended-filters {
    border-top: solid 1px $border-10p;
    margin: 6px -20px 0;
    padding: 16px 20px 0;
  }

  // Largeur par défaut : 4 filtres par ligne, les colonnes d'une ligne incomplète
  // s'étirent pour occuper toute la largeur.
  .filter-col {
    flex-basis: 25%;
  }

  // Largeurs déclarées par la config (champ `filterWidth`), pour composer une grille
  // stable : contrairement au défaut, ces colonnes ne s'étirent pas, donc les filtres
  // d'une ligne incomplète restent alignés sur ceux de la ligne du dessus.
  .filter-col--half {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .filter-col--third {
    flex: 0 0 33.3333%;
    max-width: 33.3333%;
  }

  @media (max-width: 768px) {
    .filter-col,
    .filter-col--half,
    .filter-col--third {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }
}

.select-all {
  color: $text-30p;
  text-transform: uppercase;
  letter-spacing: 0.1rem;
  @extend .clanprobold;
  line-height: 24px;
}

.total {
  height: 28px;
  line-height: 28px;
}
</style>



// WEBPACK FOOTER //
// src/components/Global/AdminTableSync.vue